import React, { Component } from 'react';

const SelectedFilterOutIcon = ({name})=>{
    return (
        <div className="filter-symb flex-center active">{name.replace('-', ' ').split(' ').map(item=> item[0].toUpperCase()).join('')}</div>
    );
};
export default SelectedFilterOutIcon;
